<template>
  <div class="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="d-flex align-items-center col-md-12 mb-4">
          <h6 class="mb-0" style="flex-basis: 8%" for>{{$lang.messages.fillter_tags}}</h6>
          <multiselect
            v-model="fillterTags"
            :options="tags"
            :multiple="true"
            label="title"
            track-by="title"
            @input="onChange"
            v-bind:placeholder="$lang.messages.please_select_option"
            :select-label="$lang.messages.please_enter_to_select"
            :selected-label="$lang.messages.selected"
            :deselect-label="$lang.messages.please_enter_to_remove"
          > <span slot="noOptions">{{$lang.messages.list_is_empty}}</span>
          </multiselect>
        </div>
      </div>
      <template v-for="tag in list">
        <h4 class="tag-title">{{ tag.title }}</h4>
        <div class="card-deck" v-if="tag.items.length > 0">
          <template v-for="(item, index) in tag.items">
            <div class="card text-center mb-4">
                <img class="card-img-top img-fluid" :src="imageBaseUrl + item.picture" :alt="item.title">
                <div class="card-body">
                    <h4 class="card-title">{{item.title}}</h4>
                    <p class="card-text text-center" v-html="item.description"></p>
                </div>
                <div class="text-center mb-3">
                  <a href="javascript:void(0)"
                    @click="trackClickURL(item.url)" class="btn btn-primary card-button">{{$lang.messages.go.toLocaleUpperCase()}}
                  </a>
                </div>
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
import { VueEditor } from "vue2-editor";
import router from "@/router";
import Multiselect from "vue-multiselect";
import EventBus from "@/eventBus";

export default {
  name: "BusinessResource",
  components: {
    Pagination,
    VueEditor,
    Multiselect,
    ErrorComponent,
    Alert
  },

  data() {
    return {
      list: [],
      tags: [],
      fillterTags: [{'title': 'Suppliers'}],
      currentUser: null
    };
  },

  methods: {
    getList() {
      let strTags = this.$_.map(this.fillterTags,'title').join(', ')
      this.$api
        .getAPI({
          _action: `/business_resource/tags-backoffice/?tags=${strTags}`,
          _body: this.filterObj
        })
        .then(res => {
          this.list = res
        })
        .catch(e => {
        });
    },
    trackClickURL(url) {
      const userID = this.currentUser && this.currentUser.user && this.currentUser.user.id || ''
      const userEmail = localStorage.getItem('loggedInUserEmail') || ''
      gtag('event', 'businessResourceClick', {
        event_category : url,
        event_label : `${userEmail}`,
        user: userID
      });
      window.open(url);
    },
    getTags() {
      this.tags = [];
      return this.$api
        .getAPI({
          _action: "/business_resource/tags/"
        })
        .then(res => {
          this.tags = res;
        });
    },
    onChange (value) {
      this.getList()
    },
  },

  mounted() {
    Promise.all([
      this.getTags()
    ]).then(res => {
        this.getList()
      }
    );

    // get current user data
    EventBus.$on("GET_ME_SUCCESS", payload => {
      this.currentUser = payload
    })
  },
};
</script>
